import { Star, Quote } from "lucide-react";
import { Reveal } from "./Reveal";
import { IMAGES } from "../../data/content";

export const Testimonial = () => (
  <section data-testid="testimonial-section" className="py-20 md:py-28 bg-white">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
      <div>
        <Reveal>
          <p className="text-[#B5651D] text-xs uppercase tracking-[0.25em] font-semibold mb-4">
            Das sagen unsere Kunden
          </p>
          <div className="flex gap-1 mb-6" data-testid="testimonial-stars">
            {[...Array(5)].map((_, i) => (
              <Star key={i} size={22} className="fill-[#B5651D] text-[#B5651D]" />
            ))}
          </div>
          <Quote size={40} className="text-[#C9B79C] mb-4" />
          <blockquote data-testid="testimonial-quote" className="font-heading text-xl md:text-2xl text-[#1F2933] leading-relaxed font-medium">
            „Unser Badezimmer wurde komplett saniert, die Fliesenarbeiten liefen
            über Lars Geffke. Eine wunderbare, supergründliche Arbeit, sieht
            wirklich schön und ästhetisch aus. Wir sind sehr zufrieden und können
            nur danken und auf jeden Fall weiterempfehlen!"
          </blockquote>
          <p className="mt-6 font-semibold text-[#1F2933]">— Familie Oelkers/Senff</p>
          <p className="text-sm text-[#4B5563]">Google-Bewertung</p>
          <p className="mt-6 text-sm text-[#4B5563] border-l-2 border-[#B5651D] pl-4">
            Unsere Kunden empfehlen uns seit Jahren weiter — überzeugen Sie sich
            selbst von unseren Google-Bewertungen und der langjährigen
            Empfehlungsquote.
          </p>
        </Reveal>
      </div>
      <Reveal delay={0.15}>
        <img
          src={IMAGES.bathroom}
          alt="Komplett saniertes, hochwertig gefliestes Badezimmer"
          className="w-full aspect-[4/3] object-cover"
        />
      </Reveal>
    </div>
  </section>
);
